<template>
  <div
    class="v-input flex flex-wrap flex-direction-column"
    :class="( label ? ' pt-4' : '')"
    :data-qa="dataQa"
    @click="$emit('click_on_block')"
    @mouseleave="inputHovering = false"
    @mouseover="inputHovering = true">
    <v-autocomplete
      ref="autocomplete"
      v-model="model_text"
      cache-items
      class="autocomplete pa-0 ma-0"
      :class="[autocomplete_class || '', {'rounded': rounded}, {'is-disabled': disabled}]"
      :color="color || 'var(--black-color)'"
      :disabled="!!disabled"
      :hide-details="hide_detail"
      hide-no-data
      :item-text="item_text"
      :item-value="item_value"
      :items="array"
      :loading="loading"
      :menu-props="menuProps"
      :multiple="multiple"
      :persistent-placeholder="!!placeholder"
      :placeholder="placeholder"
      :readonly="readonly"
      :return-object="return_object"
      :rounded="rounded"
      :rules="[true]"
      :search-input.sync="search_text"
      @blur="blur"
      @change="change"
      @focus="focus"
      @input="$emit('input', search_text )">
      <template #append>
        <div
          class="my-auto"
          :style="`color: ${color || 'var(--black-color)'};`">
          <sIcon
            v-if="not_clearable || (!not_clearable && !inputHovering)"
            size="10"
            type="arrow"/>
          <sButton
            v-if="!not_clearable && inputHovering"
            class="autocomplete__btn-clear"
            icon="cross"
            small
            type="text"
            @click="click_clear"/>
        </div>
      </template>
      <template
        v-if="item_slot"
        #item="{ item , attrs, on}">
        <slot
          :attrs="attrs"
          :item="item"
          name="item"
          :on="on"/>
      </template>
      <template
        #prepend-inner>
        <slot name="prepend-inner"/>
      </template>
      <template
        v-if="selection_slot"
        #selection="{ item, index }">
        <slot
          :index="index"
          :item="item"
          name="selection"/>
      </template>
      <template #label>
        <span
          v-if="label"
          class="h8-text black--text">{{ label }}</span>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  name: 'autocomplete',
  props: {
    autocomplete_class: String,
    not_clearable: Boolean,
    model: [String, Number, Object, Array],
    label: String,
    hide_detail: Boolean,
    items: Array,
    readonly: Boolean,
    loading: Boolean,
    search: String,
    placeholder: String,
    item_text: {
      type: String,
      value: 'text'
    },
    item_value: {
      type: String,
      value: 'id'
    },
    item_slot: Boolean,
    selection_slot: Boolean,
    show_no_data: Boolean,
    disabled: [Boolean , String, Number],
    return_object: Boolean,
    rounded: {
      type: Boolean,
      default: () => true
    },
    color: String,
    dataQa: {
      type: String,
      default: 'autocomplete'
    },
    multiple: Boolean,
    menuProps: Object
  },
  data() {
    return {
      inputHovering: false
    }
  },
  computed: {
    array: {
      get() {
        return this.items || []
      },
      set(value) {
        this.$emit('update:items', value || [])
      }
    },
    model_text: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    },
    search_text: {
      get() {
        return this.search
      },
      set(value) {
        this.$emit('update:search', value)
      }
    }
  },
  methods: {
    blur() {
      this.$emit('blur')
    },
    focus() {
      this.$emit('focus')
    },
    setRadius() {
      if ( !this.rounded ) { return }
      let self = this
      setTimeout(() => {
        let area = self.$refs.autocomplete?.$el
        if (area && area?.clientHeight > 40) {
          area.style.borderRadius = '8px'
        } else if ( area ) {
          area.style.borderRadius = '31px'
        }
      }, 50)
    },
    change(ev) {
      this.$emit('change_text', ev  )
    },
    click_clear(ev) {
      this.model_text = ''
      this.$emit('clear', ev)
    },
  },
  watch: {
    model_text() {
      this.setRadius()
    },
    items() {
      this.setRadius()
    }
  }
}
</script>
<style lang="scss">
.autocomplete {
  min-width: 170px;
  .v-label {
    transform: translateY(-30px) scale(1);
  }
  &__btn-clear {
    position: absolute;
    top: 1px;
    right: -8px;
  }
  &.is-disabled {
    border-color: var(--main__green_locked);
    background: var(--secondary__green_locked);
  }
  &.rounded:not(.is-disabled) {
    border-color: var(--v-main__green-base);
    background: var(--white-color);
  }
  &.rounded {
    position: relative;
    width: 100% !important;
    max-width: 100% !important;
    height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    border-width: 2px;
    border-style: solid;
    border-radius: 31px !important;
    &.error--text {
      border: 2px solid var(--v-secondary__red-base);
    }
    &.v-input--is-focused .material-icons {
      transform: rotate(180deg);
    }
  }
  .v-input__control {
    padding: 0 12px !important;
    height: 36px !important;
    min-height: 36px !important;
    .v-input__slot {
      background: inherit !important;
      padding: 0 !important;
    }
  }
  .v-text-field__details {
    position: absolute;
    top: 40px;
    left: 12px;
  }
  &.auto_grow {
    &, .v-input__control {
      .v-input__slot{
        margin-bottom: 0;
      }
      .item {
        padding: 5px 3px !important;
        & + input { min-width:  0;}
      }
      height: auto !important;
    }
  }
  &.theme--light.v-text-field > .v-input__control > .v-input__slot:before,
  &.theme--light.v-text-field:not(.v-input--has-state):hover > .v-input__control > .v-input__slot:before,
  &.theme--light.v-text-field > .v-input__control > .v-input__slot:after,
  &.theme--light.v-text-field:not(.v-input--has-state):hover > .v-input__control > .v-input__slot:after  {
    border-color: var(--v-main__green-base) !important;
  }
}
.menuable__content__active.v-autocomplete__content {
  border: 2px solid var(--v-main__green-base) !important;
  .v-select-list {
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    font-size: 14px;
  }
}
</style>
